import { DateTime } from "luxon"

import { LocalizedStrict } from "../../../../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../../../../modules/localization/useDateTime"
import type { ClosedDeliveryDateAudience } from "../../../../../hooks/useClosedDeliveryDateNotice"

import { DeliveryMessageBox } from "./DeliveryMessageBox"

type ClosedDateWarningMessageProps = Readonly<{
    deliveryDate: DateTime
    audience: ClosedDeliveryDateAudience
}>

/**
 * The canteen is closed on the picked date, but this user may order anyway: the order goes
 * through, so this warns instead of blocking — and must not look like the blocking box.
 */
export function ClosedDateWarningMessage({ deliveryDate, audience }: ClosedDateWarningMessageProps) {
    const dateTimeFactory = useDateTime()

    const formattedDate = dateTimeFactory.formatWeekdayLongDate(deliveryDate)

    return (
        <LocalizedStrict
            id={
                audience === "admin"
                    ? "create-order-closed-delivery-date-warning-admin"
                    : "create-order-closed-delivery-date-warning-editing"
            }
            vars={{ date: formattedDate }}
        >
            <DeliveryMessageBox tone="warning">
                Please note: The canteen is closed on {formattedDate}.
            </DeliveryMessageBox>
        </LocalizedStrict>
    )
}
